export const HIDE_SPLASH = 'HIDE_SPLASH';
export const SHOW_SPLASH = 'SHOW_SPLASH';
export const ADD_UID = 'ADD_UID';
export const HAS_ACCESS = 'HAS_ACCESS';
export const IS_LOADING = 'IS_LOADING';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const GET_DETAILS = 'GET_DETAILS';
export const SET_DETAILS = 'SET_DETAILS';
export const GET_INTERESTS = 'GET_INTERESTS';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_CHANNELS = 'GET_CHANNELS';
export const GET_VOD_CATEGORIES = 'GET_VOD_CATEGORIES';
export const GET_VOD = 'GET_VOD';
export const GET_PLAY_PAGE_DATA = 'GET_PLAY_PAGE_DATA';
export const SET_PROFILE_PIC = 'SET_PROFILE_PIC';
export const ADD_FAVORITE_CHANNELS = 'ADD_FAVORITE_CHANNELS';
export const ADD_FAVORITE_VIDEOS = 'ADD_FAVORITE_VIDEOS';
export const ADD_LIKE_CHANNELS = 'ADD_LIKE_CHANNELS';
export const ADD_LIKE_VIDEOS = 'ADD_LIKE_VIDEOS';
export const SMART_TV = 'SMART_TV';
export const SMART_TV_CHANNEL = 'SMART_TV_CHANNEL';
export const SET_HEADER_TITLE = 'SET_HEADER_TITLE';
export const ON_BACK_CLICK = 'ON_BACK_CLICK';
export const RESET_BACK_CLICK = 'RESET_BACK_CLICK';
export const ADD_HISTORY_CHANNEL = 'ADD_HISTORY_CHANNEL';
export const ADD_HISTORY_VIDEO = 'ADD_HISTORY_VIDEO';
export const CLEAR_HISTORY = 'CLEAR_HISTORY';
export const SEARCH_TEXT = 'SEARCH_TEXT';
export const SHOW_SEARCH = 'SHOW_SEARCH';
export const ADD_HISTORY_SHOW = 'ADD_HISTORY_SHOW';
export const BUCKET_ACCESS = 'BUCKET_ACCESS';
export const ADD_FEDBACK_REQUEST = 'ADD_FEDBACK_REQUEST';
export const ADD_FEDBACK_SUCCESS = 'ADD_FEDBACK_SUCCESS';
export const GET_FEDBACK_REQUEST = 'GET_FEDBACK_REQUEST';
export const GET_FEDBACK_SUCCESS = 'GET_FEDBACK_SUCCESS';
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";


// WEBPACK FOOTER //
// ./src/actions/action_types.js